import { render, staticRenderFns } from "./noticeInfo.vue?vue&type=template&id=0edae2fc&scoped=true&"
import script from "./noticeInfo.vue?vue&type=script&lang=js&"
export * from "./noticeInfo.vue?vue&type=script&lang=js&"
import style0 from "./noticeInfo.vue?vue&type=style&index=0&id=0edae2fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0edae2fc",
  null
  
)

export default component.exports